export default __webpack_public_path__ + "static/blob8-0195a5bc4b6025c76f39f7f85a634f12.svg";